export class Distributeur {
  loyout: string;
  mode: string;
  couleur_theme: string;
  couleur1: string;
  couleur2: string;
  list_offres: listetype = new listetype();
  list_contrats: listetype = new listetype();


}
export class listetype {
  included: listPerso[];
  not_included: listPerso[]
}
export class listPerso {
  key: string[]= [];
  order: any;
  libelle: string;
  
}
